export const REDEMPTION_CODE_SOURCES = {
  BEATSOURCE: "BEATSOURCE",
  TIDAL: "TIDAL",
  DJAY_PRO: "DJAY_PRO",
};

export const REDEMPTION_CODE_TYPES = {
  CODE: "CODE",
  LINK: "LINK",
};

export const REDEMPTION_CODE_SOURCES_RADIO = [
  {
    label: "Not Applicable",
    value: "",
  },
  {
    label: "BeatSource",
    value: REDEMPTION_CODE_SOURCES.BEATSOURCE,
  },
  {
    label: "Tidal",
    value: REDEMPTION_CODE_SOURCES.TIDAL,
  },
  {
    label: "djay Pro",
    value: REDEMPTION_CODE_SOURCES.DJAY_PRO,
  },
];

export const REDEMPTION_CODE_TYPES_RADIO = [
  {
    label: "Not Applicable",
    value: "",
  },
  {
    label: "Code",
    value: REDEMPTION_CODE_TYPES.CODE,
  },
  {
    label: "Link",
    value: REDEMPTION_CODE_TYPES.LINK,
  },
];